import { useQueryClient } from '@tanstack/react-query';

import { LEAD_QUERY_KEYS } from '../utils/leadApi.constants';

export function useLeadEventsCache() {
  const queryClient = useQueryClient();

  const refetchLeadEvents = async () => {
    await queryClient.refetchQueries({ queryKey: LEAD_QUERY_KEYS.events });
    return queryClient.getQueryData(LEAD_QUERY_KEYS.events) ?? [];
  };

  const invalidateLeadEvents = async () => {
    await queryClient.invalidateQueries({ queryKey: LEAD_QUERY_KEYS.events });
  };

  const getCachedLeadEvents = () =>
    queryClient.getQueryData(LEAD_QUERY_KEYS.events) ?? [];

  return {
    refetchLeadEvents,
    invalidateLeadEvents,
    getCachedLeadEvents,
  };
}
